import styled from "styled-components";
import { FLEX } from "styles/flex";
import * as mediaQuery from "components/MediaQuery";
import SubHeader from "components/blocks/subheader/SubHeader";
import BigButton from "components/atoms/buttons/BigButton";
import { InnerPaddingWrapper } from "components/atoms/inner/InnerContainer";

interface Props {
  children: React.ReactNode;
  titleComponent: React.ReactNode;
  buttons?: React.ReactNode;
  titleDescription?: React.ReactNode;
  buttonLabel?: string;
  onClickButton?: () => void;
  disabled?: boolean;
  topButton?: React.ReactNode;
  noWrapper?: boolean;
}

export default function CenterContentPage(props: Props) {
  return (
    <Container>
      <SubHeader
        titleComponent={props.titleComponent}
        noSearch
        titleDescription={props.titleDescription}
        buttons={props.topButton}
      />

      <InnerContainer noWrapper={props.noWrapper}>
        {props.children}
      </InnerContainer>
      <ButtonWrapper>
        {props.buttons
          ? props.buttons
          : props.buttonLabel &&
            props.onClickButton && (
              <BigButton
                label={props.buttonLabel}
                onClickBtn={props.onClickButton}
                disabled={props.disabled}
                data-testid="templates-layout-layout-button-click-button"
              />
            )}
      </ButtonWrapper>
    </Container>
  );
}

const Container = styled(InnerPaddingWrapper)`
  ${FLEX.FlexCenterCenter};
  flex-direction: column;
  width: 100%;
  max-width: 780px;
  margin: 0 auto;
  .subheader {
    padding-right: 0;
    padding-left: 0;
  }
  .header-container > div {
    flex: auto;
    svg {
      width: 14px;
      height: 14px;
    }
  }
`;

const InnerContainer = styled.div<{ noWrapper?: boolean }>`
  width: 100%;
  ${FLEX.FlexCenterCenter};
  flex-direction: column;
  gap: 10px;
  ${({ noWrapper, theme }) =>
    !noWrapper &&
    `
    background-color: ${theme.COLORS.WIDGETCOLOR};
    border-radius: 5px;
    padding: 26px 30px;
    ${mediaQuery.isMobile} {
        padding: 16px 20px;
    }
  `}
`;

const ButtonWrapper = styled.div`
  width: 100%;
  ${FLEX.FlexCenterCenter};
  gap: 20px;
  align-items: stretch;
  padding: 30px 0;
`;
